<template>
  <div class="bg-white">
    <CoverPage />
    <div class="">
      <!-- bg-corporateimg -->
      <div class="lg:px-12 md:px-12 px-4">
        <OurServices />
        <CuratedPrograms />
        <CaseStudies />
        <Testimonials />
      </div>
      <div class="relative">
        <img
          src="@/assets/images/line/Vector 9.png"
          alt="lineimg"
          class="m-auto px-4"
        />
        <div class="flex justify-center lg:py-0 md:py-0 relative">
          <!-- <div class="absolute left-0 -top-16">
            <img
              src="../../assets/images/caregiver/mbr-dots.svg"
              alt="bg-polygon"
              class=""
            />
          </div> -->
          <div
            class="borderprimary p-4 absolute -top-15 sm-topminu8 rounded-2xl"
          >
            <div class="bgcceff2 rounded-2xl">
              <div class="lg:flex md:flex items-center p-6">
                <p class="font-semibold text-black fsize20 sm-fsize14">
                  To partner for employee volunteering.
                </p>
                <div class="pt-3 pl-14 items-center flex">
                  <base-button
                    @click="handleClick('join-us')"
                    type="primary"
                    class="py-2 px-8 text-base font-bold border-2 md:w-auto lg:w-auto w-full fsize16-14"
                    >Contact Us</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md:hidden lg:hidden block relative mob-hidden">
      <div class="bg-corporatesvg">
        <OurServices />
      </div>
      <CuratedPrograms />
      <img
        src="./../../assets/images/line/corp-mob-2.svg"
        class="absolute md:hidden lg:hidden block"
        alt="bg"
      />
      <CaseStudies />
      <Testimonials />
      <div class="flex justify-center py-12 relative">
        <!-- <div class="absolute left-0 -top-16 mob-hidden">
          <img
            src="../../assets/images/caregiver/mbr-dots.svg"
            alt="bg-polygon"
            class=""
          />
        </div> -->
        <div
          class="borderprimary bg-white md:p-4 lg:p-4 rounded-2xl mb-12 lg:w-auto md:w-auto w-3/4"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p class="font-semibold text-black fsize20 sm-fsize14">
                Your contribution can help us
                <span class="lg:block md:block">
                  empower the marginalised caregiver</span
                >
              </p>
              <div class="md:pl-12 lg:pl-14 pl-0 items-center flex mx-auto">
                <!-- <a
                  href="https://pages.razorpay.com/caregiversaathi-donation"
                  alt="link"
                  target="_blank"
                  class="w-full"
                >
                  </a  > -->
                <base-button
                  type="primary"
                  @click="handleClick('donation')"
                  class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 mx-auto md:w-auto lg:w-auto w-full"
                  >Donate</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HcpPartners />
    <div class=""><Membership /></div>
    <div class="lg:pt-64 md:pt-64 sm-35rem">
      <LatestGrid />
    </div>
    <FAQ />
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import OurServices from "./components/OurServices.vue";
import CuratedPrograms from "./components/CuratedPrograms.vue";
import CaseStudies from "./components/CaseStudies.vue";
import Testimonials from "./components/Testimonials.vue";
import HcpPartners from "./components/HcpPartners.vue";
import Membership from "./components/Membership.vue";
import FAQ from "./components/FAQ.vue";
import LatestGrid from "./components/LatestGrid.vue";
import Form from "./components/Form.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    CoverPage,
    OurServices,
    CuratedPrograms,
    CaseStudies,
    Testimonials,
    Membership,
    FAQ,
    LatestGrid,
    DownloadApp,
    Footer,
    HcpPartners,
    Form,
  },
  metaInfo: {
    title: "Corporate Services - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Caregiver Saathi partners with progressive organisations to enable caregiver friendly practices for employees & boost productivity. We help you get future ready!",
      },
    ],
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-35rem {
    padding-top: 35rem !important;
  }
  .sm-topminu8 {
    top: -8rem;
  }
}
</style>
